import React, { Component } from 'react'
import { submitEnquery } from '../../action/enquiry';
import Form from '../../Component/Enquiry/index'
import constant from '../../constant';
import Swal from 'sweetalert2';
import Loader from '../../old_Components/Common/Loader';
import Info from '../../Component/Enquiry/Info'
export default class OnlineSalesEnquirys extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showLoader: false

        }
    }
    componentDidMount() {
        document.title = constant.title.OnlineSalesEnquiry
    }

    onSubmit = (model) => {
        this.setState({ showLoader: true });
        submitEnquery(model).then(res => {
            if (res.status) {
                this.setState({ showLoader: false });
                Swal.fire({
                    icon: 'success',
                    text: res.result.message,
                    timer: 1500,
                    showCancelButton: false,
                    showConfirmButton: false
                })
                window.location.reload()
            }
            else {
                Swal.fire({
                    icon: 'error',
                    text: res.error,
                    timer: 1500,
                    showCancelButton: false,
                    showConfirmButton: false
                })
            }
        })
    }

    render() {
        return (
            <React.Fragment>
                {this.state.showLoader && <Loader />}
                <Form
                    onSubmit={this.onSubmit}
                />
                <Info/>
            </React.Fragment>
        )
    }
}